<template>
    <v-card tile>
        <v-tabs
        v-model="tab"
        background-color="primary"
        dark
        center-active
        show-arrows
        >
            <v-tab>Job Settings</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item>
                <v-card flat>
                    <v-card-text>
                        <ValidationObserver ref="observer1">
                            <v-form ref="jobform">
                                <v-list flat>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <ValidationProvider v-slot="{ errors }" name="Customer" rules="required">
                                                <v-autocomplete
                                                    v-model="form.customer"
                                                    :items="customers"
                                                    :loading="isLoading"
                                                    :search-input.sync="search"
                                                    hide-no-data
                                                    hide-selected
                                                    item-text="label"
                                                    item-value="value"
                                                    label="Customer"
                                                    placeholder="Start typing to Search"
                                                    prepend-icon="mdi-database-search"
                                                    return-object
                                                    required
                                                    :error-messages="errors"
                                                ></v-autocomplete>
                                            </ValidationProvider>

                                            <ValidationProvider v-slot="{ errors }" name="Cleaner" rules="required">
                                                <v-select
                                                    v-model="form.cleaner"
                                                    :items="cleaners"
                                                    item-text="label"
                                                    item-value="value"
                                                    label="Cleaner"
                                                    required
                                                    :error-messages="errors"
                                                ></v-select>
                                            </ValidationProvider>

                                            <v-datetime-picker 
                                                label="Job Date/Time" 
                                                v-model="form.datetime" 
                                                date-format="MM/dd/yyyy" 
                                                time-format="hh:mm a"
                                            ></v-datetime-picker>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-form>
                        </ValidationObserver>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>                        
                        <v-btn large min-width="50%" color="blue darken-1" text to="/jobs">Cancel</v-btn>              
                        <v-btn large min-width="50%" color="primary" tile @click="submit" :loading="loading">Create Job</v-btn>
                    </v-card-actions>  
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import axios from 'axios'

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})

export default {
    data () {
        return {
            customers: [],
            tab: null,
            form: {
                customer: '',
                cleaner: '',
                datetime: ''
            },
            loading: false,
            isLoading: false,
            search: null,
        }
    },
    watch: {
      search (val) {
        // Items have already been requested
        if (this.isLoading) return

        this.isLoading = true

        axios.get('admin/customers/search', {
            params: {
                keyword: val
            }
        })
        .then(response => {
            this.customers = response.data.customers
            this.$nextTick()
        })
        .catch(err => {
            console.log(err)
        })
        .finally(() => (this.isLoading = false))
      },
    },
    computed: {
        ...mapGetters({
            cleaners: 'data/cleaners'
        }),
    },
    components: {
        ValidationProvider,
        ValidationObserver
    },
    methods: {
        ...mapActions({
            addJob: 'data/addJob',
        }),
        async submit() {
            let valid1 = await this.$refs.observer1.validate()

            if(valid1 && this.form.datetime != null && this.form.datetime != '') {
                this.loading = true
                this.addJob(this.form).then(response => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved!')
                    this.$router.push({ path: `/job/${response.id}` })
                }).catch(error => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    if(error.response.data.error) {
                        this.$store.commit('SET_SNACK', error.response.data.error)
                    } else {
                        this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                    }
                })
            } else {
                this.$store.commit('SET_SNACKTYPE', 'red')
                if(this.form.datetime != null || this.form.datetime != '') {
                    this.$store.commit('SET_SNACK', 'Please set the Job Date & Time.')
                } else {
                    this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                }
            }
        },
    }
}
</script>

<style lang="sass" scoped>
.estimation
    background: #003e72
    color: #fff
    text-align: center
    justify-content: center
    font-size: 20px
    margin: -16px -16px 20px
header
    &.quote-bar
        position: sticky
        top: 0
        z-index: 999
.admin-action 
    background: #1976d2
    button 
        width: 95%
        background: #ffffff
        color: #1976d2
.comment-actions 
    background: #dadada
</style>
<style lang="sass">
.filepond--drop-label
    &.filepond--drop-label label
        margin: 0
        color: #fff
        font-size: 20px
        text-transform: uppercase
        font-size: 16px
        line-height: 1em

.filepond--panel-root
    background: #003a6f
    border-radius: 0
    color: #fff!important
    border: 3px dashed #ffffff

.images
    text-align: center

    img 
        max-width: 100%

.comment-text
    white-space: pre-wrap

.public
    label 
        font-size: 13px

.theme--light
    &.status
        background: #e0f2f5
</style>